module.exports = __webpack_public_path__ + "static/img/project2.5609fb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project2.png
// module id = 1IzG
// module chunks = 1